import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@honda-canada/design-system-react';
import SelectProducts from '../SelectProducts/index';
import themeStyles from './styles/PriceAndFinance.styles';

const Container = themeStyles.apply(Box, 'Container');

const PriceAndFinanceLayout = ({ productCatalogData, availableProductLines }) => (
  <Container data-testid="price-and-finance-container">
    <SelectProducts dropdownList={productCatalogData} availableProductLines={availableProductLines} />
  </Container>
);

PriceAndFinanceLayout.propTypes = {
  productCatalogData: PropTypes.shape({}),
  availableProductLines: PropTypes.arrayOf(PropTypes.string),
};
export default PriceAndFinanceLayout;
